<!-- 心得详情 -->
<template>
  <div class="detail">
    <topBack></topBack>
    <barF5></barF5>
    <div class="titleRange">
      <div class="title">{{content.title}}</div>
      <div class="titleOther">{{content.other}}</div>

    </div>
    <div class="content">{{content.content}}</div>

    <div class="blank"></div>
    <barF5></barF5>
    <!-- 底部button -->
    <!-- <footer>
      <Button></Button>
    </footer> -->
  </div>
</template>

<script>
  import topBack from '../../components/topBack.vue'
  import barF5 from "../../components/barF5"; //空隙bar
  import Button from "../../components/button"; //返回首頁
  export default {
    name: "",
    components: {
      topBack,
      barF5,
      Button
    },
    props: {},
    data() {
      return {
        content: {
          title: "關於力量的一點體會",
          other: "志　誠",
          content: "耕雲先生出生於一九二四年農曆五月一日天津市。乳名「大有」。幼入私塾，學名「連元」，字「仲三」，十二歲讀完《四書》及《左傳》。 一九四二年隨軍駐西康，依瑪西其安上師習學白教密法，得灌頂為阿奢黎。一九四九年隨軍到台灣，一九八三年秋退休。 先生感於國事，更名為「挽」，在台期間，深痛天涯淪落，海角飄零，乃銳志參禪，於一九七四年桃園龍潭軍中「桶底脫落」，了畢大事。一九八二年應禪學會之請求， 允為導師，為有緣「解粘去縛，抽釘拔楔」，迄二○○○年圓寂，計十八年整，其間歷次所說法要，名曰「安祥禪」 ，印有專輯，弘揚寰宇，頗獲有緣信受奉行，無異佛陀在世。 先生之禪，一掃公案、葛藤，作風平實，法力則不可思議，聆聞開示者，每於言下證入金剛心體，恢復心的原態（本來面目），信乎「以心傳心」 之不誣也。 先生少言身世，謹集所聞片段，由弟子拾綴如上。"
        }
      };
    }
  };
</script>

<style scoped>
  .detail {
    background-color: #F5F5F5;
  }

  .titleRange {
    padding: 1rem 0.64rem;
    background-color: #ffffff;
  }

  .title {
    font-size: 0.85rem;
    line-height: 1.5rem;
    color: #333333;
    font-weight: 600;
  }

  .titleOther {
    height: 0.8rem;
    font-size: 0.69rem;
    line-height: 1.49rem;
    color: #999999;
    font-size: 0.8rem;
  }

  .content {
    padding: 0.64rem;
    line-height: 1.5rem;
    color:#666666;
    font-size: 0.69rem;
    text-align: left;
    font-size: 0.85rem;
  }

  .blank {
    width: 100%;
    height: 3rem;
    background-color: #ffffff;
  }
</style>